import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import { selectIsShowTransactionModal, setIsShowTransactionModal } from 'features/home/homeSlice';
import React, { Fragment, useEffect, useState } from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { platformStates } from 'redux/platformSlice';
import ExternalTransactionModal from './ExternalTransactionModal';
import VinpayOrderModal from './VinpayOrderModal';
import { ExceptionMap } from 'antd/lib/result';
import { uniqueId } from 'utils/commonUtils';
import Typo from 'consts/typography';
import FiatTransactionModal from './FiatTransactionModal';
import SwapTransactionModal from './SwapTransactionModal';

interface TransactionModalProps {}

const TransactionModal: React.FunctionComponent<TransactionModalProps> = () => {
  const isShow = useAppSelector(selectIsShowTransactionModal);
  const dispatch = useAppDispatch();
  const t = useAppTranslation();
  const [currentTab, setCurrentTab] = useState<number>(1);
  const platform = useAppSelector(platformStates);

  useEffect(() => {
    if (isShow) {
      document.body.classList.add('overlay-active');
    } else {
      document.body.classList.remove('overlay-active');
    }
  }, [isShow]);

  const handleCloseModal = () => {
    setCurrentTab(1);
    dispatch(setIsShowTransactionModal(false));
  };

  const textButtons = [
    {
      value: 1,
      label: t('transactionHistory.tab.external'),
    },
    {
      value: 2,
      label: t('transactionHistory.tab.vinpay'),
    },
    {
      value: 3,
      label: t('transactionHistory.tab.fiat'),
    },
    {
      value: 4,
      label: t('transactionHistory.tab.swap'),
    },
  ];

  return (
    <div
      className={`overlay z-500 center-content-col primary-text-color ${
        isShow ? 'show' : 'hidden'
      }`}
    >
      <div className="transaction-modal">
        <div className="transaction-modal__header">
          <h1 className="title">{t('transactionHistory.title')}</h1>
          <button onClick={handleCloseModal} className="close-modal">
            <AiOutlineCloseCircle />
          </button>
        </div>
        <div className="transaction-modal__container">
          <div className=" flex flex-row items-center justify-between my-bets-tab gap-2">
            {textButtons.map((x) => (
              <button
                key={uniqueId()}
                className={`transaction-modal__button cursor-pointer ${
                  platform.isDesktop || platform.isLargeDesktop ? Typo.p1 : Typo.p3
                } ${currentTab === x.value ? 'active' : ''}`}
                onClick={() => setCurrentTab(x.value)}
              >
                {x.label}
              </button>
            ))}
          </div>

          {isShow && (
            <Fragment>
              {currentTab === 1 && <ExternalTransactionModal />}
              {currentTab === 2 && <VinpayOrderModal />}
              {currentTab === 3 && <FiatTransactionModal />}
              {currentTab === 4 && <SwapTransactionModal />}
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default TransactionModal;
